(() => {
  function setup() {
    document.querySelectorAll('[id*="featured_collection_itEANW"] slider-component').forEach(host => {
      if (host.dataset.autoscrollReady) return;
      const track = host.querySelector('ul.product-grid');
      if (!track || track.children.length < 2) return;
      host.dataset.autoscrollReady = 'true';
      const originals = Array.from(track.children);
      const viewport = document.createElement('div');
      viewport.className = 'bestseller-motion-viewport';
      track.before(viewport);
      viewport.append(track);
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const copies = originals.map(item => {
        const copy = item.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        copy.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
        copy.querySelectorAll('.scroll-trigger').forEach(el => el.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen'));
        track.append(copy);
        return copy;
      });
      track.classList.add('bestseller-smooth-track');
      host.classList.add('bestseller-motion-host');
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'bestseller-motion-toggle';
      toggle.setAttribute('aria-pressed', 'false');
      const pauseLabel = document.documentElement.lang.startsWith('de') ? 'Animation pausieren' : 'Pause animation';
      const playLabel = document.documentElement.lang.startsWith('de') ? 'Animation fortsetzen' : 'Resume animation';
      toggle.textContent = pauseLabel;
      viewport.after(toggle);
      let animation, distance = 0, visible = true, paused = false, hovered = false, focused = false;
      const speed = 14;
      const sync = () => {
        if (animation) {
          if (paused || hovered || focused || !visible || document.hidden) animation.pause();
          else animation.play();
        }
      };
      const measure = () => {
        const progress = distance > 0 && animation ? (Number(animation.currentTime) / (distance / speed * 1000)) % 1 : 0;
        animation?.cancel();
        animation = null;
        copies.forEach(copy => { if (reduced.matches) copy.style.setProperty('display', 'none', 'important'); else copy.style.removeProperty('display'); });
        distance = copies[0].offsetLeft - originals[0].offsetLeft;
        toggle.hidden = reduced.matches;
        if (reduced.matches || distance <= 0) { track.style.transform = 'none'; return; }
        track.style.removeProperty('transform');
        const duration = distance / speed * 1000;
        animation = track.animate([{ transform: 'translate3d(0,0,0)' }, { transform: `translate3d(${-distance}px,0,0)` }], { duration, iterations: Infinity, easing: 'linear' });
        animation.currentTime = focused ? 0 : progress * duration;
        sync();
      };
      toggle.addEventListener('click', () => { paused = !paused; toggle.textContent = paused ? playLabel : pauseLabel; toggle.setAttribute('aria-pressed', String(paused)); sync(); });
      viewport.addEventListener('mouseenter', () => { hovered = true; sync(); });
      viewport.addEventListener('mouseleave', () => { hovered = false; sync(); });
      viewport.addEventListener('focusin', () => { focused = true; if (animation) animation.currentTime = 0; sync(); });
      viewport.addEventListener('focusout', event => { if (!viewport.contains(event.relatedTarget)) { focused = false; sync(); } });
      document.addEventListener('visibilitychange', sync);
      reduced.addEventListener('change', measure);
      const resize = new ResizeObserver(measure);
      resize.observe(viewport);
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
      observer.observe(host);
      track.querySelectorAll('img').forEach(img => { if (!img.complete) img.addEventListener('load', measure, { once: true }); });
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(host)) return;
        animation?.cancel(); resize.disconnect(); observer.disconnect();
        document.removeEventListener('visibilitychange', sync);
        reduced.removeEventListener('change', measure);
      });
      measure();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
